import { useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import {
  selectDevicesByMapId,
} from "../../../store/deviceStore/deviceSelectors";
import DeviceMapContainer from "../../Map/DeviceMapContainer";
import useDevicesPage from "../../DevicesPage/devicePageHooks";
import useFilter from "../../../hooks/filter.hook";
import { useEffect } from "react";
import {
  setCoverageSettings,
  setFilterPanelVisibility,
  setShowIndoorDeviceList
} from "../../../store/filterStore/filterState";
import { useTypedDispatch } from "../../../app/state";
import BreadcrumbsContainer from "../../Shared/BreadcrumbsContainer";

const CentralDeviceMapPanel = () => {
  const dispatch = useTypedDispatch();
  const { state } = useDevicesPage();
  const filter = useFilter();
  const { currentMapId, currentMap } = state;
  const currentPlaceDevices = useSelector(selectDevicesByMapId(currentMapId));
  const filteredDeviceList = filter.actions.filterDeviceList(currentPlaceDevices);

  useEffect(() => {
    return () => {
      // clear coverage filters and visible panel on map close
      dispatch(setFilterPanelVisibility(null));
      dispatch(setShowIndoorDeviceList(false));

      dispatch(
        setCoverageSettings({
          powerLossCoefficient: null,
          interferenceLevel: null,
        })
      );
    }
  }, []);

  return (
    <Grid container item xs direction='column'>
      <BreadcrumbsContainer
        showLastItemLink
        getPathFromDevice
        items={
          [ BreadcrumbsContainer.TYPES.LOCATION, BreadcrumbsContainer.TYPES.BUILDING, BreadcrumbsContainer.TYPES.FLOOR, BreadcrumbsContainer.TYPES.DEVICE_MAP, BreadcrumbsContainer.TYPES.DEVICE ]
        }
      />
      <DeviceMapContainer
        map={currentMap}
        deviceList={filteredDeviceList}
      />
    </Grid>
  );
};

export default CentralDeviceMapPanel;